import { type z } from "zod"
import { type PartnerLinks } from "../types/partnerLink"
import { type PartnerRoutes } from "../types/partnerRoutes"
import { links } from "./links"
import { Partner } from "./partner"
import { routes } from "./routes"
import { session } from "./session"

const PARTNERS_LOGO_BASE_PATH = "/assets/images/partners"
const getLogoPath = (partner: string) => `${PARTNERS_LOGO_BASE_PATH}/${partner}.svg`

type Config = {
    name: string
    affiliateCode?: string
    GTMId: string
    // globalStyle?: GlobalStyle
    logo?: {
        src: string
        alt: string
    }
    altLogo?: {
        src: string
        alt: string
    }
    footer?: {
        links: PartnerLinks
        shouldDisplayPrivacyPolicy?: boolean
    }
    portail?: {
        links: PartnerLinks
    }
    routes?: PartnerRoutes
    session?: {
        schema: z.ZodTypeAny
        authResponseSchema: z.ZodTypeAny
        getExpiration: () => Date
    }
}

type PartnersConfig = Record<Partner, Config> & {
    default: Config
}

export const PARTNERS_CONFIG: PartnersConfig = {
    default: {
        name: "Octopus Energy",
        GTMId: "GTM-N83JRCM",
    },
    [Partner.Darty]: {
        name: "Darty Energies",
        affiliateCode: "onboarding-darty", // TODO: update to apply Darty partnership only on navigator
        GTMId: "GTM-N83JRCM", // TODO: Waiting for Darty GTM ID, using Octopus one for now
        logo: {
            src: getLogoPath(Partner.Darty),
            alt: "Darty",
        },
        portail: {
            links: links.darty,
        },
        routes: routes.darty,
        session: session.darty,
    },
    [Partner.DartyOctopus]: {
        name: "Darty Energies (Espace Octopus)",
        GTMId: "GTM-N83JRCM",
        logo: {
            src: getLogoPath(Partner.Darty),
            alt: "Darty",
        },
        portail: { links: links.darty },
        routes: routes.darty,
        session: session.dartyOctopus,
    },
    [Partner.Effy]: {
        name: "Effy",
        affiliateCode: "offre-effy",
        GTMId: "GTM-N83JRCM",
        logo: {
            src: getLogoPath(Partner.Effy),
            alt: "Effy",
        },
        routes: routes.effy,
    },
}
